module.exports = __webpack_public_path__ + "img/icon-subway.f941e23c.svg";